export function viewAllFunc() {
  let ajaxList = $('#ajaxList');
  let moreBtn = $('#moreBtn');
  let moreBtnTxt = $('#moreBtn p');
  let moreBtnSpan = $('#moreBtn span');
  let accordionArea = $('.accordionArea');
  //let url = "http://tenga-rocket-production.test/wp/wp-admin/admin-ajax.php";
  accordionArea.hide();
  moreBtn.on("click", function () {
    /*
    $.ajax({
        type: 'POST',
        url: url,
        data: {
          'action' : 'my_ajax_get_posts',
        },
        success: function( data ){
          ajaxList.append(data);
          moreBtn.addClass('hide');
        }
    });
    return false;
    */
    accordionArea.stop().slideToggle(600);
    moreBtn.toggleClass('open');
    if(moreBtn.hasClass('open')){
      moreBtnTxt.text('Close');
      moreBtnSpan.text('Close');
    } else {
      moreBtnTxt.text('View All');
      moreBtnSpan.text('View All');
    }
  });
}
